import { BuzerIcon } from "../../../BuzerIcons";
import { DIFF_STARS, normDifficulty } from "../../../lib/points";
import { Lead } from "./ListRow";

// v29 §8.1 — miniatúra: ikona v krúžku a POD ňou riadok 1–3 hviezdičiek náročnosti.
// Jeden vzor pre návyk aj výzvu (preto primitív, nie inline v BuzerFeature.jsx).
//   level  — náročnosť ("easy"|"normal"|"hard"); počet hviezdičiek = DIFF_STARS[level]
//   stars  — alternatíva k `level`, keď payload nesie rovno `stars` (1|2|3)
//   active — hviezdičky vo farbe témy (inak tiché --neutral-text-muted)
//   size/shape/tone/style — prechádzajú do <Lead> (rovnaké API ako doteraz)
//   lead   — v30: VLASTNÝ uzol namiesto <Lead>. Výzva má vlastný chip (TypeChip s rožným
//            markerom), ktorý sa doň predtým nedal vložiť — volajúci to musel obchádzať tak,
//            že marker vyňal von. Keď je `lead` zadaný, `children` ani leadProps sa nepoužijú.
// V Lite režime sa hviezdičky nekreslia (§8.3) — nastav `stars={0}` / `level={null}`,
// alebo použi priamo <Lead>.
export function LeadWithStars({ level, stars, active = false, lead, children, ...leadProps }) {
  const n = stars != null ? Number(stars) || 0 : (level != null ? DIFF_STARS[normDifficulty(level)] : 0);
  const node = lead != null ? lead : <Lead {...leadProps}>{children}</Lead>;
  if (n <= 0) return node;
  return (
    <div className="bz-leadstars">
      {node}
      <span className={`bz-leadstars__stars${active ? " bz-leadstars__stars--on" : ""}`} aria-hidden="true">
        {Array.from({ length: n }).map((_, i) => (
          <BuzerIcon key={i} name="star" size={9} color="currentColor" />
        ))}
      </span>
    </div>
  );
}
